class Auth {
  constructor() {
    this.sessionToken = null
    this.storage = window.localStorage
    // Clean up old format tokens on initialization
    this.cleanupOldToken()
  }

  isLocalStorageNameSupported = () => {
    let testKey = 'test'
    try {
      this.storage.setItem(testKey, '1')
      this.storage.removeItem(testKey)
      return true
    } catch (error) {
      return false
    }
  }

  // Check if token is old format (JSON.signature) and remove it
  cleanupOldToken = () => {
    const token = this.storage.token || this.sessionToken
    if (token && token.startsWith('{')) {
      // Old format token detected, remove it to force re-login
      this.removeToken()
    }
  }

  setToken = (token) => {
    document.cookie = `token=` + token + `; expires=Mon, 17 Sep 2030 00:00:00 UTC; path=/`
    if (this.isLocalStorageNameSupported()) {
      this.storage.token = token
    } else {
      this.sessionToken = token
    }
  }

  removeToken = () => {
    if (this.isLocalStorageNameSupported()) {
      this.storage.removeItem('token')
      document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
    }
    this.sessionToken = null
  }

  getToken = () => {
    const token = this.sessionToken || this.storage.token
    // Double check: if old format, return undefined to force login
    if (token && token.startsWith('{')) {
      this.removeToken()
      return undefined
    }
    return token
  }
}


export default new Auth()



// WEBPACK FOOTER //
// ./src/auth.js